import { render, staticRenderFns } from "./LogisticsForm.vue?vue&type=template&id=360e9ddc&scoped=true"
import script from "./LogisticsForm.vue?vue&type=script&lang=js"
export * from "./LogisticsForm.vue?vue&type=script&lang=js"
import style0 from "./LogisticsForm.vue?vue&type=style&index=0&id=360e9ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360e9ddc",
  null
  
)

export default component.exports